import { getConfig } from '@/configProvider';

export enum ENV_ENUM {
    dev = 'dev',
    pre = 'pre',
    beta = 'beta',
    release = 'release',
}

// 判断国际化产品域名后缀,
// 国内为 cn
// designkit 和海外为 com
export const getDomainName = () => {
    const { appName, isIntl } = getConfig();
    return (appName === 'designkit' && isIntl) || isIntl ? 'com' : 'cn';
};

/**
 * DesignKit全球化api域名
 */
export const webApiUrlDesignKitMap: Record<ENV_ENUM, string> = {
    [ENV_ENUM.dev]: 'https://pre.designkit.com/api',
    [ENV_ENUM.pre]: 'https://pre.designkit.com/api',
    [ENV_ENUM.beta]: 'https://beta.designkit.com/api',
    [ENV_ENUM.release]: 'https://www.designkit.com/api',
};

/**
 * 国内api域名
 */
export const getWebApiUrlMap = (): Record<ENV_ENUM, string> => {
    return {
        [ENV_ENUM.dev]: `https://prewebapi.designkit.cn`,
        [ENV_ENUM.pre]: `https://prewebapi.designkit.cn`,
        [ENV_ENUM.beta]: `https://betawebapi.designkit.cn`,
        [ENV_ENUM.release]: `https://webapi.designkit.cn`,
    };
};

/**
 * 海外api域名
 */
export const webApiUrlStariiMap: Record<ENV_ENUM, string> = {
    [ENV_ENUM.dev]: 'https://pre.zawa.ai/api',
    [ENV_ENUM.pre]: 'https://pre.zawa.ai/api',
    [ENV_ENUM.beta]: 'https://beta.zawa.ai/api',
    [ENV_ENUM.release]: 'https://zawa.ai/api',
};

/**
 * 国内api域名
 */
export const subApiUrlMap: Record<ENV_ENUM, string> = {
    [ENV_ENUM.dev]: 'https://pre-api-h5-sub.meitu.com',
    [ENV_ENUM.pre]: 'https://pre-api-h5-sub.meitu.com',
    [ENV_ENUM.beta]: 'https://beta-api-h5-sub.meitu.com',
    [ENV_ENUM.release]: 'https://api-h5-sub.meitu.com',
};

/**
 * 海外api域名
 */
export const subApiUrlStariiMap: Record<ENV_ENUM, string> = {
    [ENV_ENUM.dev]: 'https://pre-api-h5-sub.starii.com',
    [ENV_ENUM.pre]: 'https://pre-api-h5-sub.starii.com',
    [ENV_ENUM.beta]: 'https://beta-api-h5-sub.starii.com',
    [ENV_ENUM.release]: 'https://api-h5-sub.starii.com',
};

export const getEnvPrefix = (env: string) => {
    return env === 'beta' ? 'beta' : env === 'release' ? '' : 'pre';
};

export const getApiHost = () => {
    const { isIntl, appName } = getConfig();

    if (isIntl && appName === 'x-design') {
        return webApiUrlStariiMap[getConfig().env];
    } else if (isIntl && appName === 'designkit') {
        return webApiUrlDesignKitMap[getConfig().env];
    }

    return getWebApiUrlMap()[getConfig().env];
};

export const getSubApiHost = () => {
    const { isIntl, appName } = getConfig();
    return isIntl && appName === 'x-design' ? subApiUrlStariiMap[getConfig().env] : subApiUrlMap[getConfig().env];
};
